export const defaultIngredient: Ingredient = {
    name: "",
    price: {
        value: 0,
        unit: "euro"
    },
    mass: {
        value: 0,
        unit: "g"
    }

}
export const defaultRecipe: Recipe = {
    name: "",
    description: "",
    height: {
        value: 0,
        unit: "cm"
    },
    diameter: {
        value: 0,
        unit: "cm"
    },
    mass: {
        value: 0,
        unit: "g"
    },
    ingredients: []
}

export const defaultRecipeIngredient : RecipeIngredient = {
    name: "",
    mass: {
        value: 0,
        unit: "g"
    }
} as const
